var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaticon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H31.9956C40.8322 0 47.9956 7.16344 47.9956 16V31.9956C47.9956 40.8322 40.8322 47.9956 31.9956 47.9956H16C7.16344 47.9956 0 40.8322 0 31.9956V16Z",
    fill: "#2F91F8",
    fillOpacity: 0.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9929 32.997V30.9972C27.9929 29.9364 27.5715 28.9191 26.8214 28.169C26.0713 27.4189 25.054 26.9976 23.9932 26.9976H17.9938C16.933 26.9976 15.9157 27.4189 15.1656 28.169C14.4155 28.9191 13.9941 29.9364 13.9941 30.9972V32.997",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9937 22.9988C23.2028 22.9988 24.9937 21.2079 24.9937 18.9988C24.9937 16.7896 23.2028 14.9988 20.9937 14.9988C18.7845 14.9988 16.9937 16.7896 16.9937 18.9988C16.9937 21.2079 18.7845 22.9988 20.9937 22.9988Z",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9922 32.9977V30.9977C33.9915 30.1114 33.6965 29.2505 33.1536 28.55C32.6106 27.8495 31.8503 27.3493 30.9922 27.1277",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9927 15.1287C28.8531 15.349 29.6157 15.8494 30.1603 16.551C30.7049 17.2526 31.0005 18.1155 31.0005 19.0037C31.0005 19.8918 30.7049 20.7547 30.1603 21.4564C29.6157 22.158 28.8531 22.6584 27.9927 22.8787",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticon03);
export default __webpack_public_path__ + "static/media/staticon03.020519d860092ebb6648dbb18288dc40.svg";
export { ForwardRef as ReactComponent };